import { withLazy } from '../../hoc/lazy'

export const LazyLoad = withLazy(({ children }) => <>{children}</>)

LazyLoad.displayName = 'Hive-LazyLoad'

export default LazyLoad
